import React from "react";
import banner from "../assets/trainings.jpg";
import { Card } from "primereact/card";
export default function Trainings() {
  return(

    <div>
       <div
        style={{
          width: "100%",
          height: "300px",         
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",  
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff"
        }}
      >
        <h1>Our Trainings</h1>
      </div>
      <div className="p-5">
      <div className="center-text-section">
        <h2>Overview of Trainings provided by PESIL</h2>
        <p>
         We provides trainings in IBM products
        </p>
      </div>
    <div className="grid mt-5">

  <div className="col-12 md:col-6 flex">
    <div className="hover-card w-full">
      <Card
        title="IBM DOORS Next Generation Training-Fundamentals"
        className="h-full flex flex-column"
      >
        <p>
          One of the main components of the Rational solution for Collaborative Lifecycle Management (CLM).
          The product provides requirements definition and requirements management capabilities.
        </p>
      </Card>
    </div>
  </div>

  <div className="col-12 md:col-6 flex">
    <div className="hover-card w-full">
      <Card
        title="IBM Engineering Test Management (ETM)"
        className="h-full flex flex-column"
      >
        <p>
          Designed to help users filter and retrieve comments made within modules...
        </p>
      </Card>
    </div>
  </div>

  <div className="col-12 md:col-6 flex">
    <div className="hover-card w-full">
      <Card
        title="IBM JAZZ Team Server Administration Training"
        className="h-full flex flex-column"
      >
        <p>
          This course provides a deeper insight into the architecture of the IBM Jazz platform.
        </p>
      </Card>
    </div>
  </div>

  <div className="col-12 md:col-6 flex">
    <div className="hover-card w-full">
      <Card
        title="IBM Rational Publishing Engine Training"
        className="h-full flex flex-column"
      >
        <p>
          This course teaches developers and engineers how to define and configure reporting templates.
        </p>
      </Card>
    </div>
  </div>

  <div className="col-12 md:col-6 flex">
    <div className="hover-card w-full">
      <Card
        title="DOORS Classic Training"
        className="h-full flex flex-column"
      >
        <p>
          This Course teaches System Engineers on using DOORS Classic.
        </p>
      </Card>
    </div>
  </div>

</div>


    </div>
      </div>
  )
}
